(function (root) {
  'use strict';
  const choices = { training: ['general', 'olympic', 'power', 'mixed'], fastening: ['lever', 'prong', 'flexible', 'unsure'], fit: ['narrow', 'standard', 'fit_unsure'], style: ['classic', 'printed', 'personal', 'either'] };
  function valid(a) { return a && Object.keys(choices).every(k => choices[k].includes(a[k])) && !(a.training === 'power' && a.fastening === 'flexible') && !(a.training === 'olympic' && a.fastening === 'lever'); }
  function resolve(a) {
    if (!valid(a)) return null;
    let type = a.fastening === 'lever' ? 'lever' : a.fastening === 'flexible' ? 'flex' : a.training === 'power' ? 'prong' : 'weight';
    const narrow = a.fit === 'narrow' && ['lever', 'prong'].includes(type);
    const base = type + (narrow ? '_narrow' : '');
    const personal = a.style === 'personal' && type !== 'flex';
    const groups = type === 'flex' ? ['flex_classic'] : personal ? [type + '_personal'] : a.style === 'either' ? [base + '_classic', base + '_printed'] : [base + '_' + a.style];
    return { type, narrow, personal, groups, key: personal ? 'custom_' + type : type, competition: a.training === 'power', reason: type === 'weight' && a.training === 'olympic' ? 'olympic_reason' : type + '_reason' };
  }
  root.MFBeltJourney = { resolve, valid };
  if (typeof module !== 'undefined' && module.exports) module.exports = root.MFBeltJourney;
  if (typeof document === 'undefined') return;
  if (root.mfBeltChooserInstalled) return;
  root.mfBeltChooserInstalled = true;
  const dialog = document.getElementById('mf-belt-chooser');
  if (!dialog) return;
  const config = JSON.parse(dialog.querySelector('[data-mf-config]').textContent);
  const text = config.text, form = dialog.querySelector('form');
  const steps = [...form.querySelectorAll('[data-mf-step]')];
  const next = form.querySelector('[data-mf-next]'), back = form.querySelector('[data-mf-back]');
  const result = form.querySelector('[data-mf-result]'), restart = form.querySelector('[data-mf-restart]');
  const prongImage = form.querySelector('input[name="fastening"][value="prong"]').closest('label').querySelector('img');
  const powerProngImage = { src: prongImage.getAttribute('src'), srcset: prongImage.getAttribute('srcset') };
  const weightProngImageUrl = 'https://cdn.shopify.com/s/files/1/0075/0252/8612/files/GokuWL02.jpg?v=1716161029';
  const storageKey = 'modifit_belt_selection_v1';
  let step = 0, opener = null, overflow = '', resultVersion = 0, templatePromise;
  const answers = () => Object.fromEntries(new FormData(form));
  function savedAnswers() {
    try { const data = JSON.parse(localStorage.getItem(storageKey)); return data && data.expires > Date.now() && valid(data.answers) ? data.answers : null; } catch (_) { return null; }
  }
  function previewUrl(path) {
    const url = new URL(path || config.urls.all, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  function render(focus = true) {
    dialog.dataset.photoStep = String(step === 1 || step === 3);
    dialog.dataset.resultStep = String(step === 4);
    const velcro = form.querySelector('input[name="fastening"][value="flexible"]');
    const competing = answers().training === 'power';
    const lever = form.querySelector('input[name="fastening"][value="lever"]');
    const olympic = answers().training === 'olympic';
    lever.closest('label').hidden = olympic;
    lever.disabled = olympic;
    if (olympic) lever.checked = false;
    const prongSrc = competing ? powerProngImage.src : weightProngImageUrl + '&width=480';
    const prongSrcset = competing ? powerProngImage.srcset : weightProngImageUrl + '&width=240 240w, ' + weightProngImageUrl + '&width=480 480w';
    if (prongImage.getAttribute('srcset') !== prongSrcset) prongImage.setAttribute('srcset', prongSrcset);
    if (prongImage.getAttribute('src') !== prongSrc) prongImage.setAttribute('src', prongSrc);
    velcro.closest('label').hidden = competing; velcro.disabled = competing;
    if (competing) velcro.checked = false;
    dialog.querySelector('[data-mf-selection]').hidden = step === 0;
    dialog.querySelector('[data-mf-selected]').textContent = text[answers().training] || '';
    dialog.querySelectorAll('.mfbc__meter span').forEach((el, i) => { el.classList.toggle('is-complete', i < step); el.classList.toggle('is-current', i === step); });
    steps.forEach((el, i) => { el.hidden = i !== step; });
    result.hidden = step !== 4; next.hidden = step === 4; back.hidden = step === 0; restart.hidden = step !== 4;
    next.textContent = step === 3 ? text.results : text.next;
    next.disabled = step < 4 && !steps[step].querySelector(':checked');
    dialog.querySelector('[data-mf-progress]').textContent = step < 4 ? text.step + ' ' + (step + 1) + ' ' + text.of + ' 4' : '';
    dialog.querySelector('[data-mf-progress]').hidden = step === 4;
    if (focus) { (step < 4 ? steps[step].querySelector('legend') : result).focus({ preventScroll: true }); dialog.scrollTop = 0; }
  }
  async function templates() {
    if (!templatePromise) {
      templatePromise = (async () => {
        const url = previewUrl(root.Shopify?.routes?.root || '/');
        url.searchParams.set('section_id', 'mf-belt-shortlist-data');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Could not load belt selection');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!doc.querySelector('template[data-mf-product-group]')) throw new Error('Selection unavailable');
          return doc;
        } finally { clearTimeout(timeout); }
      })().catch(error => { templatePromise = null; throw error; });
    }
    return templatePromise;
  }
  async function recommend() {
    const a = answers(), match = resolve(a); if (!match) return;
    const version = ++resultVersion;
    dialog.querySelector('[data-mf-reason]').textContent = text[match.reason] + (match.narrow ? ' ' + text.narrow_reason : '');
    dialog.querySelector('[data-mf-result-style]').textContent = match.personal ? text.custom_reason : text[a.style + '_reason'] || '';
    dialog.querySelector('[data-mf-competition]').hidden = !match.competition;
    dialog.querySelector('[data-mf-thickness]').hidden = !['lever', 'prong'].includes(match.type);
    dialog.querySelector('[data-mf-fit]').textContent = text.measure + ' ' + (match.type === 'weight' ? text.weight_short : text.fit_unknown);
    const card = config.recommendations[match.key] || config.recommendations.all;
    dialog.querySelector('[data-mf-result-title]').textContent = (match.narrow ? '3″ ' : '') + card.title;
    const styleUrl = !match.personal && !match.narrow ? config.styleUrls?.[match.type]?.[a.style] : null;
    let destination = styleUrl || config.urls[match.key] || config.urls.all;
    if (match.narrow && !match.personal) destination = config.urls[match.type + '_narrow'] || destination;
    dialog.querySelector('[data-mf-destination]').href = previewUrl(destination).href;
    dialog.querySelector('[data-mf-timing]').textContent = match.personal ? text.timing_custom : text.timing_product;
    const note = dialog.querySelector('[data-mf-special-note]');
    note.textContent = match.type === 'flex' && a.style === 'personal' ? text.custom_flex : match.narrow && match.personal ? text.narrow_custom : '';
    note.hidden = !note.textContent;
    const grid = dialog.querySelector('[data-mf-products]'); grid.replaceChildren(); grid.setAttribute('aria-busy', 'true');
    const empty = dialog.querySelector('[data-mf-empty]'); empty.hidden = true;
    dialog.querySelector('[data-mf-save-status]').textContent = text.save_help;
    dialog.querySelector('[data-mf-forget]').hidden = !savedAnswers();
    try {
      const doc = await templates(); if (version !== resultVersion) return;
      const sets = match.groups.map(group => [...(doc.querySelector('template[data-mf-product-group="' + group + '"]')?.content.querySelectorAll('[data-mf-product]') || [])]);
      const selected = [], ids = new Set();
      for (let index = 0; index < 4; index++) for (const set of sets) {
        const product = set[index]; if (!product || ids.has(product.dataset.mfProduct) || selected.length >= 4) continue;
        ids.add(product.dataset.mfProduct); selected.push(product.cloneNode(true));
      }
      for (const product of selected) {
        product.querySelectorAll('a').forEach(link => { const url = previewUrl(link.getAttribute('href')); url.searchParams.set('mf_belt_match', match.groups[0]); link.href = url.href; });
        grid.append(product);
      }
      empty.hidden = selected.length > 0;
      empty.textContent = a.style === 'printed' ? text.unavailable_style : text.empty;
    } catch (_) { if (version === resultVersion) { empty.hidden = false; empty.textContent = text.empty; } }
    finally { if (version === resultVersion) grid.removeAttribute('aria-busy'); }
  }
  function applyAnswers(a) {
    for (const [key, value] of Object.entries(a)) {
      const input = form.querySelector('input[name="' + key + '"][value="' + value + '"]'); if (input) input.checked = true;
    }
  }
  function open(trigger, saved) {
    opener = trigger || document.querySelector('[data-mf-chooser-open]');
    if (saved) { applyAnswers(saved); step = 4; recommend(); }
    if (!dialog.open) { overflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; dialog.showModal(); }
    render();
  }
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-mf-chooser-open], [data-mf-resume]'); if (!trigger) return;
    event.preventDefault();
    const parent = trigger.closest('header-sidebar, x-drawer');
    const returnFocus = parent ? document.querySelector('[aria-controls="' + parent.id + '"]') : trigger;
    if (parent && typeof parent.hide === 'function') await parent.hide();
    open(returnFocus || trigger, trigger.hasAttribute('data-mf-resume') ? savedAnswers() : null);
  });
  dialog.querySelector('[data-mf-change]').addEventListener('click', () => { step = 0; render(); });
  form.addEventListener('change', () => render(false));
  form.addEventListener('submit', event => { event.preventDefault(); if (step >= 4 || !steps[step].querySelector(':checked')) return; step++; if (step === 4) recommend(); render(); });
  back.addEventListener('click', () => { resultVersion++; step = Math.max(0, step - 1); render(); });
  restart.addEventListener('click', () => { resultVersion++; form.reset(); step = 0; render(); });
  dialog.querySelector('[data-mf-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { document.documentElement.style.overflow = overflow; opener?.focus(); });
  function refreshSavedLinks() { document.querySelectorAll('[data-mf-resume]').forEach(el => { el.hidden = !savedAnswers(); }); }
  dialog.querySelector('[data-mf-save]').addEventListener('click', () => {
    try { localStorage.setItem(storageKey, JSON.stringify({ answers: answers(), expires: Date.now() + 30 * 86400000 })); dialog.querySelector('[data-mf-save-status]').textContent = text.saved; refreshSavedLinks(); dialog.querySelector('[data-mf-forget]').hidden = false; }
    catch (_) { dialog.querySelector('[data-mf-save-status]').textContent = text.save_failed; }
  });
  dialog.querySelector('[data-mf-forget]').addEventListener('click', () => { try { localStorage.removeItem(storageKey); } catch (_) {} refreshSavedLinks(); dialog.querySelector('[data-mf-forget]').hidden = true; dialog.querySelector('[data-mf-save-status]').textContent = text.save_help; });
  refreshSavedLinks();
  const entry = new URL(location.href).searchParams.get('belt_finder');
  const trainingMap = { general: 'general', olympic: 'olympic', powerlifting: 'power', unsure: 'mixed' };
  if (Object.prototype.hasOwnProperty.call(trainingMap, entry)) { applyAnswers({ training: trainingMap[entry] }); step = 1; open(); }
})(typeof window !== 'undefined' ? window : globalThis);
